import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { GlobalFilterService } from '../../services/filters/global-filter.service';
import { AccountsService } from '../../services/accounts/accounts.service';
import * as _ from 'lodash'
import { HelpersService } from '../../services/helpers/helpers.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { HierarhyFilterButtonComponent } from './sub-component/hierarhy-filter-button/hierarhy-filter-button.component';
import { ActiveFiltersChipsComponent } from './sub-component/active-filters-chips/active-filters-chips.component';
import { NgIf } from '@angular/common';
import { HuddleCreationComponent } from '../../../features/projects/huddle/huddle-creation/huddle-creation.component';
import { AddFiltersButtonComponent } from './sub-component/add-filters-button/add-filters-button.component';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { FiltersConfig } from '../config';

@Component({
    selector: 'app-ltms-global-filter-draw',
    templateUrl: './ltms-global-filter-draw.component.html',
    styleUrls: ['./ltms-global-filter-draw.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        HierarhyFilterButtonComponent,
        ActiveFiltersChipsComponent,
        NgIf,
        HuddleCreationComponent,
        AddFiltersButtonComponent,
    ]
})
export class LtmsFilterDrawComponent implements OnInit, OnDestroy {

  globalHierarchyLevels = {};
  mappedHierarchyLevelNames: any = {};
  isHierarchyFilterInitialised: boolean = false;
  isActiveFiltersEnabled: boolean = false;
  hierarchy_filter: any = [];
  brandDetails: any = [];
  appliedFilter: any = {}; // Initially use for default access
  appliedFilterTrail: string = '';
  isHierarchFilterActive: boolean = false;
  isUniversalFilterActive: boolean = false;
  isHuddleCreationSidebarOpen: boolean = false;
  loggedInUserLevel;
  loggedInUserValues;
  project_id;
  activeUniversalFilter: any = {
    question_filter: false,
    text_filter: false,
    transaction_filter: false,
    action_filter: false
  }
  selectedHierarchyValue: string = ''
  isHierarchyInitializing: boolean = false;
  manager_type: any = null;
  access_key: any = null;
  defaultAccess: any = {};

  isAccount: boolean = false;
  accountId: string = ''
  projectId: string = ''
  activeTab: string = ''
  isAddfilterBtnEnabled: boolean = true;
  isHierarchyFilterEnabled: boolean = true;
  isHierarchFilterHidden: boolean = false;
  isUniversalFilterEnabled: boolean = false;
  isHuddleFilterEnabled: boolean = false;
  private isSettingsRoute: boolean = false; // Flag to track if we're on settings route
  private previousUrl: string = ''; // Track previous URL to detect route changes
  private routerSubscription?: Subscription; // Subscription for router events
  constructor(
    private globalFilterService: GlobalFilterService,
    private accountsService: AccountsService,
    private _helpers: HelpersService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    // Check route immediately in constructor to set flag before any subscriptions
    let url = this._router.url || '';
    this.isSettingsRoute = url.includes('/settings/') || url.includes('/interaction');
    
    // Open hierarchy side bar
    this.globalFilterService.globalFilterState$.subscribe(() => {
      this.activateCustomFilters();
    })
    this.globalFilterService.hideHierarchyFilter.subscribe((flag)=>{
      // Always check current route before modifying visibility
      let url = this._router.url || '';
      let routeData = this.prepareRouteData(url)
      const isSettings = routeData.routeName == 'interaction' || 
                        routeData.level == 'settings' || 
                        url.includes('/settings/');
      
      if (isSettings) {
        // Always hide filter on settings route
        this.isSettingsRoute = true;
        this.isHierarchFilterHidden = true;
        return;
      }
      
      // Not on settings route
      this.isSettingsRoute = false;
      
      if(!flag) {
        // Flag is false - check for other conditions that should hide the filter
        let urlParams = new URLSearchParams(document.location.search);
        let tabName = urlParams.get('active_tab')
        this.isHierarchFilterHidden = (tabName === 'quickinsights')?true:false; // Hide hierarchy filter for Quick Insights tab
      } else {
        // Flag is true - but we're not on settings, so check if there are other reasons to hide
        // If we're here and not on settings, we should show the filter unless there's another reason
        let urlParams = new URLSearchParams(document.location.search);
        let tabName = urlParams.get('active_tab')
        const hideFilterOnTab = ['quickinsights'];
        if (tabName && hideFilterOnTab.indexOf(tabName) >= 0) {
          this.isHierarchFilterHidden = true;
        } else {
          // Show the filter if not on settings and no other reason to hide
          this.isHierarchFilterHidden = false;
        }
      }
    })
  }
  ngOnInit(): void {
    this.isHierarchyInitializing = true
    this.doEmpty();
    
    // Check route immediately on first load to set filter visibility before initializing
    let url = this._router.url || '';
    this.previousUrl = url; // Initialize previous URL
    let routeData = this._helpers.prepareRouteData(url)

    this.updateFilterVisiblity(routeData)
    
    this.initHierarchyFilter();
    
    // Subscribe to router events to detect route changes (including navigation from settings to scores)
    this.routerSubscription = this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        let url = event.urlAfterRedirects || this._router.url || '';
        let routeData = this._helpers.prepareRouteData(url)
        this.updateFilterVisiblity(routeData);
        this.previousUrl = url;
      });
    
    this._route.queryParams.subscribe(params => {
      let url = this._router.url || '';
      let activeTab = params['active_tab']
      let accountId = params['account_id'];
      let projectId = params['project_id']
      this.isAccount = (_.isNull(projectId) || !projectId) ? true : false;
      let routeData = this._helpers.prepareRouteData(url)

      // Check if URL changed (route path change, not just query params)
      const urlPath = url.split('?')[0]; // Get path without query params
      const previousUrlPath = this.previousUrl.split('?')[0];
      const routeChanged = urlPath !== previousUrlPath;

      // Update filter visibility if:
      // 1. Route path changed (e.g., from settings to scores)
      // 2. Query params changed (accountId, projectId, activeTab)
      // 3. First load (accountId, projectId, activeTab are undefined)
      const paramsChanged = this.accountId != accountId || 
                           this.projectId != projectId || 
                           this.activeTab != activeTab;
      
      if (routeChanged || paramsChanged || 
          (this.accountId === undefined && this.projectId === undefined && this.activeTab === undefined)) {
        this.updateFilterVisiblity(routeData)
        this.accountId = accountId;
        this.projectId = projectId;
        this.activeTab = activeTab;
        this.previousUrl = url; // Update previous URL
      }
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from router events to prevent memory leaks
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  prepareRouteData(urlstr: string) {
    let url = urlstr.split('?')[0];
    let paramStr = urlstr.split('?')[1];
    let routeData: any = {}
    if (url != '') {
      const urlarr = url.split('/');
      routeData.url = urlstr
      routeData.level = urlarr[urlarr.length - 2];
      routeData.routeName = urlarr[urlarr.length - 1];
    }
    if (paramStr && paramStr != '') {
      let paramarray = paramStr.split("&")
      _.each(paramarray, (qyerystr: string) => {
        const arr = qyerystr.split("=")
        routeData[arr[0]] = arr[1]
      })
    }
    return routeData;
  }

  updateFilterVisiblity(routeData: any) {
    const hideFilterOnRotue = ['action', 'engagement', 'outbox'];
    const hideFilterOnTab = ['quickinsights']

    // Check for settings/interaction FIRST - these should always hide the filter
    // Also check URL directly as fallback in case route parsing fails
    const currentUrl = this._router.url || '';
    const isSettingsRoute = routeData.routeName == 'interaction' || routeData.level == 'settings' || currentUrl.includes('/settings/');

    let config: any = FiltersConfig.default;
    if (_.hasIn(routeData, 'subRouteName') && routeData.subRouteName != '' && routeData.subRouteName != undefined && _.hasIn(FiltersConfig, `${routeData.level}.${routeData.routeName}.${routeData.subRouteName}`)) {
      if (_.hasIn(FiltersConfig, `${routeData.level}.${routeData.routeName}.${routeData.subRouteName}.${routeData.active_tab}`)) {
        config = _.get(FiltersConfig, `${routeData.level}.${routeData.routeName}.${routeData.subRouteName}.${routeData.active_tab}`);
      } else {
        config = _.get(FiltersConfig, `${routeData.level}.${routeData.routeName}.${routeData.subRouteName}`);
      }
    } else if (_.hasIn(FiltersConfig, `${routeData.level}.${routeData.routeName}`)) {
      if (_.hasIn(FiltersConfig, `${routeData.level}.${routeData.routeName}.${routeData.active_tab}`)) {
        config = _.get(FiltersConfig, `${routeData.level}.${routeData.routeName}.${routeData.active_tab}`);
      } else {
        config = _.get(FiltersConfig, `${routeData.level}.${routeData.routeName}`);
      }
    }
    this.isSettingsRoute = (routeData.routeName == 'settings') ? true : false;
    if (!_.isEmpty(config)) {
      this.isUniversalFilterEnabled = config.isUniversalFilterenabled || false;
      this.isHuddleFilterEnabled = config.isHuddleFilterEnabled || false;
      this.isAddfilterBtnEnabled = (this.isUniversalFilterEnabled || this.isHuddleFilterEnabled)?true:false;

      this.isHierarchyFilterEnabled = config.isHierarchyFilterEnabled || false;
      this.isHierarchFilterHidden = !this.isHierarchyFilterEnabled;
      this.globalFilterService.hideHierarchyFilterFn(this.isHierarchFilterHidden);
    }
  }
  doEmpty() {
    this.globalHierarchyLevels = {};
    this.mappedHierarchyLevelNames = {};
    this.hierarchy_filter = [];
    this.appliedFilter = {};
    this.loggedInUserLevel = null;
    this.loggedInUserValues = null;
  }
  reloadComponent() {
    // this.activateCustomFilters();
    // this.initHierarchyFilter();

  }
  openHuddleCreationSidebar() {
    this.isHuddleCreationSidebarOpen = true; // Set the flag to true when the sidebar is opened
  }
  closeHuddleCreationSidebar() {
    this.isHuddleCreationSidebarOpen = false; // Close the sidebar
  }
  // Open applied global hierarchy filter on click
  openGlobalFilterSideBar(event: any, filterType: string) {
    if (event) event.stopPropagation();
    // if(this.manager_type == 3 && this.loggedInUserLevel == 'touchpoint'){
    if (!this.isHierarchyFilterInitialised && event && event.target && event.target.value) {
      const globalFilter = this.globalFilterService.getAppliedFilters()
      if (globalFilter && globalFilter.by_hierarchy_drilldown) {
        let appliedhierarchy = globalFilter.by_hierarchy_drilldown;
        if (appliedhierarchy[0].value != event.target.value) {
          appliedhierarchy[0].value = event.target.value;
          const data = { 'by_hierarchy_drilldown': appliedhierarchy };
          const hierarchyStack = this.globalFilterService.getHierarchyStack(appliedhierarchy);
          this.globalFilterService.setValuesForGlobalUse({ globalFilter: data, type: 'applied_hierarchy_filter' });
          this._helpers.setHierarchyStack(hierarchyStack)
          // this.renderGlobalFilter()
        }
      }
    } else {
      this.renderGlobalFilter(filterType)
    }
    // }
  }


  initHierarchyFilter() {
    // Call service to get logged in manager default access
    this.globalFilterService.getDefaultAccess((parameter) => {
      this.manager_type = _.get(parameter, 'manager_type');
      this.access_key = _.get(parameter, 'access_key');
      if (!parameter || parameter == undefined) {
        console.warn('Error Here, have to handle it, You dont have project level access'); // #todo
      } else {
        if (parameter && parameter['project_id'] && parameter.manager_type != 3) {
          this.project_id = parameter['project_id'];
          // Get brand details
          this.getBrandDetails(parameter.project_id, (brandDetail) => {
            if (brandDetail && _.has(brandDetail, 'is_single_touchpoint_setup') && brandDetail['is_single_touchpoint_setup'] == true && parameter.access_key != undefined) {
              // Store logged in manager level and values
              if (!this.isHierarchyFilterInitialised) {
                this.loggedInUserLevel = Object.keys(parameter.access_key)[0];
                this.loggedInUserValues = parameter.access_key[this.loggedInUserLevel].values;
                if (this.selectedHierarchyValue == '') {
                  this.selectedHierarchyValue = this.loggedInUserValues[0]
                }
              }
              this.globalFilterService.setMappedHierarhcyLevels(brandDetail, (data) => {
                this.mappedHierarchyLevelNames = data.mappedHierarchyLevelNames;
                this.defaultAccess = {
                  "key": this.loggedInUserLevel,
                  "label": this.mappedHierarchyLevelNames[this.loggedInUserLevel],
                  "options": this.loggedInUserValues,
                  "value": this.selectedHierarchyValue,
                  "enabled": true
                }
                if(data && data.hierarchyMapping && data.hierarchyMapping.length){
                  const levelIndex = _.findIndex(data.hierarchyMapping,{key:this.loggedInUserLevel})
                  if(levelIndex == data.hierarchyMapping.length -1){
                    this.isHierarchyFilterEnabled = false;
                  }else{
                    this.isHierarchyFilterEnabled = true;
                  }
                }
                this.isHierarchyInitializing = false;
              })
            } else {
              this.setDefaultTouchpointLevel(parameter)
            }
          })
        } else {
          this.setDefaultTouchpointLevel(parameter)
        }
      }
    });
  }
  // Need to implement hierarhcy fallback for manager_type:3 or static project
  setDefaultTouchpointLevel(parameter) {
    this.project_id = parameter['project_id'];
    this.mappedHierarchyLevelNames["touchpoints"] = "Touchpoints";
    this.loggedInUserLevel = "touchpoints"
    this.loggedInUserValues = ["All Touchpoints"]
    this.isHierarchyInitializing = false;
  }

  getBrandDetails(project_id, cb) {
    const brandDetails = _.get(Helpers, 'brandDetails', {})
    if(brandDetails && brandDetails['_id'] && brandDetails['_id'] == project_id){
      this.brandDetails=brandDetails;
      
      cb(brandDetails)
      this.canShowNewHuddleButton();
    }else{
      this.accountsService.getBrandDetail(project_id).subscribe((result: any) => {
        if (result && result.code == 0) {
        //   this.brandDetails = result.data.brand;
          if (result.data && result.data.brand) {
            cb(result.data.brand)
           // this.canShowNewHuddleButton();
          }else{
            cb({});
          }
        }
      });
    }
  }

  //To show new huddle creation button this function will check huddle rules for new huddle
  canShowNewHuddleButton(): boolean {
    // Check if "huddle" exists in the URL
    const currentUrl = window.location.href;
    const isHuddleRoute = currentUrl.includes('/huddle');
  
    if (isHuddleRoute && this.brandDetails?.action_management_configuration?.huddle) {
      const newHuddleRule = this.brandDetails.action_management_configuration.huddle.rules.visibility.new_huddle;
      if (newHuddleRule.operator === 'in') {
        return newHuddleRule.value.includes(this.loggedInUserLevel);
      }
    }
    
    return false;
  }
  activateCustomFilters() {
    this.isHierarchyInitializing = true;
    this.appliedFilterTrail = '';
    this.isActiveFiltersEnabled = false;
    this.isUniversalFilterActive = false;
    this.activeUniversalFilter = {
      question_filter: false,
      text_filter: false,
      transaction_filter: false,
      action_filter: false
    }
    
    // Always check current route to set filter visibility correctly
    // This ensures visibility is correct even if called after navigation
    let url = this._router.url || '';
    let routeData = this.prepareRouteData(url)
    const isSettings = routeData.routeName == 'interaction' || 
                      routeData.level == 'settings' || 
                      url.includes('/settings/');
    
    if (isSettings) {
      // Settings route - hide the entire filter
      this.isSettingsRoute = true;
      this.isHierarchFilterHidden = true;
      this.globalFilterService.hideHierarchyFilterFn(true);
    } else {
      // Not on settings - show the filter for all other routes (action, engagement, outbox, scores, inbox, etc.)
      this.isSettingsRoute = false;
      this.isHierarchFilterHidden = false;
      this.globalFilterService.hideHierarchyFilterFn(false);
    }
    let global_filter_data = this.globalFilterService.getAppliedFilters();
    let univeralFilters = this.globalFilterService.getUniveralFilters()
    // Draw active default access or Applied filter
    if ((global_filter_data && global_filter_data['by_hierarchy_drilldown']) || (global_filter_data && global_filter_data['by_hierarchy_level_and_value'])) {
      let hiearchyFilter = (global_filter_data['by_hierarchy_drilldown']) ? global_filter_data['by_hierarchy_drilldown'] : global_filter_data['by_hierarchy_level_and_value'];
      if (hiearchyFilter && ((hiearchyFilter.length > 1 && global_filter_data['by_hierarchy_drilldown']) || (global_filter_data['by_hierarchy_level_and_value']))) {
        let hierarchyLevel2: any;
        if(global_filter_data['by_hierarchy_drilldown']) {
          hierarchyLevel2 = hiearchyFilter[1];
        }else if(global_filter_data['by_hierarchy_level_and_value']) {
          hierarchyLevel2 = hiearchyFilter;
        }
        if (hierarchyLevel2 && hierarchyLevel2.value != 'All' && hierarchyLevel2.value != "ALL") {
          this.isHierarchFilterActive = true;
        } else {
          this.isHierarchFilterActive = false;
        }
      } else {
        if (hiearchyFilter && hiearchyFilter.length) {
          this.loggedInUserLevel = _.get(hiearchyFilter, '0.key', this.loggedInUserLevel)
          this.selectedHierarchyValue = _.get(hiearchyFilter, '0.value', this.selectedHierarchyValue)
          this.loggedInUserValues = _.get(hiearchyFilter, '0.options', [this.selectedHierarchyValue]);
        }
        this.isHierarchFilterActive = false;
        this.isHierarchyInitializing = false;
      }
    }
    if (this.isHierarchFilterActive) {
      this.isActiveFiltersEnabled = true;
    }

    if (univeralFilters && univeralFilters.filters && univeralFilters.filters.length) {
      _.each(univeralFilters.filters, (object: any) => {
        if (object.filterType == "question_filter") {
          this.activeUniversalFilter.question_filter = true;
        }
        if (object.filterType == "text_filter") {
          this.activeUniversalFilter.text_filter = true;
        }
        if (object.filterType == "transaction_filter") {
          this.activeUniversalFilter.transaction_filter = true;
        }
        if (object.filterType == "action_filter") {
          this.activeUniversalFilter.action_filter = true;
        }
      })
      this.isUniversalFilterActive = true;
      this.isActiveFiltersEnabled = true;
    }
    // Draw selected hierarchy trail
    if (global_filter_data && global_filter_data['by_hierarchy_drilldown']) {
      this.hierarchy_filter = global_filter_data['by_hierarchy_drilldown'];
      this.hierarchy_filter.forEach(list => {
        if (list.value) {
          this.appliedFilterTrail += list.label +':  '+ list.value + '<span class="aling-trail">></span>';
        }
      });
      if (this.appliedFilterTrail.length > 0) {
        this.appliedFilterTrail = this.appliedFilterTrail.substring(0, (this.appliedFilterTrail.length - 8)); // Removing string "> " from last
      }
    }
    if(global_filter_data && global_filter_data['by_hierarchy_level_and_value']) {
      let appliedHierarchy = global_filter_data['by_hierarchy_level_and_value'];
      if(appliedHierarchy && appliedHierarchy.label != 'Select level') {
        this.isHierarchFilterActive = true
        this.appliedFilterTrail += appliedHierarchy.label + " : " + appliedHierarchy.value;
      }else {
        // Reset to my current access by_hierarchy_level_and_value
        this.isHierarchFilterActive = false;
        this.appliedFilterTrail = '';
      }
    }
    this.isHierarchyInitializing = false;
    // this.initHierarchyFilter();
  }

  clearActiveFilters(event: any, filterType: string) {
    event.stopPropagation();
    let univeralFilters = this.globalFilterService.getUniveralFilters()
    univeralFilters.filters = _.filter(univeralFilters.filters, (filter: any) => {
      return (filter.filterType != filterType)
    })
    delete univeralFilters.filterId
    const formatedFilters = this.globalFilterService.getFormatedUniversalFilter(univeralFilters);
    this.globalFilterService.storeUniversalFilters(univeralFilters);
    this._helpers.setUniversalFilters(formatedFilters);
  }
  // Check if object is empty
  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  renderGlobalFilter(filterType: string) {
    const tabs = ["question_filter", "text_filter", "transaction_filter", "action_filter"];
    var values = this.mappedHierarchyLevelNames;
    for (let key in values) {
      if (key >= this.loggedInUserLevel) {
        this.globalHierarchyLevels[key] = values[key];
      }
    }
    let tabData: any = {}
    if (filterType == "hierarchy") {
      tabData = {
        hierarchyLevels: this.globalHierarchyLevels,
        project_id: this.project_id,
        tabName: "by_hierarchy",
        filterType: filterType
      };
    } else if (filterType == "universal_filter") {
      tabData = {
        tabName: "by_dimension",
        filterType: filterType
      };
    } else if (tabs.indexOf(filterType) >= 0) {
      tabData = {
        tabName: "active_filter",
        filterType: filterType
      }
    }
    tabData.isHierarchyFilterEnabled = this.isHierarchyFilterEnabled;
    tabData.isUniversalFilterEnabled = (this.isAddfilterBtnEnabled)?true:false;
    // Hierarchy block click event from header & prevent displaying By Hierarchy from side bar global filter
    if ((this.manager_type == 3 && this.loggedInUserLevel == 'touchpoints') || (this.manager_type == 2 && this.access_key == undefined)) {
      tabData.isHierarchyFilterEnabled = false;
    }

    // Here need to pass selected option if user have multi value access
    this.globalFilterService.sendClickEventToOPenHierarchyGlobalFilter(tabData);

  }

  updateHierarchyFilter(event: any) {
    let global_filter_data = this.globalFilterService.getAppliedFilters();
    let hierarchyFilter: any = [];
    if (global_filter_data.by_hierarchy_drilldown && global_filter_data.by_hierarchy_drilldown.length) {
      hierarchyFilter = global_filter_data.by_hierarchy_drilldown
    } else if (global_filter_data.by_hierarchy_level_and_value && global_filter_data.by_hierarchy_level_and_value.length) {
      hierarchyFilter = global_filter_data.by_hierarchy_level_and_value
    }
    if (hierarchyFilter && hierarchyFilter.length) {
      hierarchyFilter[0].value = this.selectedHierarchyValue
      hierarchyFilter = _.map(hierarchyFilter, (object: any, index: number) => {
        if (index == 0) {
          object.enabled = true
          return object
        } else if (index == 1) {
          object.options = ["ALL"],
            object.value = "ALL"
          object.enabled = true
        } else {
          object.options = ["ALL"],
            object.value = "ALL"
          object.enabled = false
        }
      })
      let hierarchyStack = this.globalFilterService.getHierarchyStack(hierarchyFilter);
      this.globalFilterService.setValuesForGlobalUse({ globalFilter: { 'by_hierarchy_drilldown': Helpers.deepClone(hierarchyFilter) }, type: 'applied_hierarchy_filter' });
      this._helpers.setHierarchyStack(hierarchyStack);
    }
  }
}
